import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if we're in the middle of a redirect
  if (window.location.hash.includes('code=') || window.location.hash.includes('error=')) {
    console.log('Processing authentication redirect...');
    return true;
  }

  // Wait for authentication initialization, then check signal
  return from(authService.initializeAuthentication()).pipe(
    map(() => {
      if (authService.isAuthenticated()) {
        console.log('Auth guard: User authenticated after initialization');
        return true;
      } else {
        console.log('Auth guard: User not authenticated after initialization');
        return false;
      }
    })
  );
};